import type { PointerEventModifiers } from '../../../types/pointer-events.js';
import type { InteractionMode } from '../types.js';

export const getActiveMode = (
  mode: InteractionMode,
  event?: PointerEventModifiers,
  zoomDisabled: boolean = false,
  panDisabled: boolean = false,
) => {
  if (event) {
    if ((event.metaKey || event.ctrlKey) && !zoomDisabled) {
      return 'zoom';
    } else if (event.altKey && !panDisabled) {
      return 'pan';
    }
  }

  return mode;
};
